/**
 * ROAVE Collection — sidebar toggle (desktop + mobile), sort dropdown, price filter
 * No AJAX — all filtering is URL-based via Shopify's native filter URLs.
 */
(function () {
  'use strict';

  var sidebar = document.querySelector('[data-roave-sidebar]');
  var overlay = document.querySelector('[data-roave-sidebar-overlay]');
  var filterBtn = document.querySelector('[data-roave-filter-toggle]');
  var closeBtn = document.querySelector('[data-roave-sidebar-close]');
  var sortBtn = document.querySelector('[data-roave-sort-toggle]');
  var sortMenu = document.querySelector('[data-roave-sort-menu]');

  var desktopMQ = window.matchMedia('(min-width: 768px)');

  /* ── Filter sidebar ────────────────────────── */

  /* Mobile: slide in/out with fixed overlay */
  function openMobile() {
    if (!sidebar) return;
    sidebar.classList.add('roave-col__sidebar--open');
    if (overlay) overlay.classList.add('roave-col__overlay--visible');
    document.body.style.overflow = 'hidden';
  }

  function closeMobile() {
    if (!sidebar) return;
    sidebar.classList.remove('roave-col__sidebar--open');
    if (overlay) overlay.classList.remove('roave-col__overlay--visible');
    document.body.style.overflow = '';
  }

  /* Desktop: toggle visibility in layout */
  function toggleDesktop() {
    if (!sidebar) return;
    sidebar.classList.toggle('roave-col__sidebar--hidden');
  }

  function handleFilterClick() {
    if (desktopMQ.matches) {
      toggleDesktop();
    } else {
      openMobile();
    }
  }

  if (filterBtn) filterBtn.addEventListener('click', handleFilterClick);
  if (closeBtn) closeBtn.addEventListener('click', closeMobile);
  if (overlay) overlay.addEventListener('click', closeMobile);

  /* Close mobile sidebar on Escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMobile();
  });

  /* ── Sort dropdown ─────────────────────────── */

  function toggleSort() {
    if (!sortMenu) return;
    sortMenu.classList.toggle('roave-col__sort-menu--open');
  }

  if (sortBtn) sortBtn.addEventListener('click', toggleSort);

  document.addEventListener('click', function (e) {
    if (sortBtn && sortMenu && !sortBtn.contains(e.target) && !sortMenu.contains(e.target)) {
      sortMenu.classList.remove('roave-col__sort-menu--open');
    }
  });

  /* ── Price filter form ─────────────────────── */

  var priceForms = document.querySelectorAll('.roave-col__price-form');
  priceForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var params = new URLSearchParams(window.location.search);
      var inputs = form.querySelectorAll('.roave-col__price-input');
      inputs.forEach(function (input) {
        if (input.value) {
          params.set(input.name, (parseFloat(input.value) * 100).toString());
        } else {
          params.delete(input.name);
        }
      });
      window.location.search = params.toString();
    });
  });
})();
